// client/src/components/ProtectedRoute.js
import React, { useEffect, useState } from 'react';
import { useUser } from '@clerk/clerk-react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children }) {
  const { user, isSignedIn, isLoaded } = useUser();
  const [isUserInitialized, setIsUserInitialized] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    if (isLoaded && isSignedIn && user) {
      const initializeUser = async () => {
        try {
          console.log('Initializing user in MongoDB:', user.id);
          
          const response = await fetch('/api/create-user', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              clerkId: user.id,
              email: user.primaryEmailAddress?.emailAddress
            }),
          });
          
          if (response.ok) {
            console.log('User initialized successfully in MongoDB');
            setIsUserInitialized(true);
          } else {
            console.error('Failed to initialize user in MongoDB');
          }
        } catch (error) {
          console.error('Error initializing user:', error);
        } finally {
          setIsChecking(false);
        }
      };
      
      initializeUser();
    } else if (isLoaded && !isSignedIn) {
      setIsChecking(false);
    }
  }, [isLoaded, isSignedIn, user]);

  if (!isLoaded || isChecking) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>;
  }
  
  if (!isSignedIn) {
    return <Navigate to="/sign-in" />;
  }
  
  return children;
}

export default ProtectedRoute;